import React from 'react'

const Info = (props: any) => {
  const { width = 32, height = 32 } = props

  return (
    <svg width={width} height={height} viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd" opacity={0.5}>
        <path d="M6 6h20v20H6z" />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M16 7.667A8.336 8.336 0 0 0 7.667 16c0 4.6 3.733 8.333 8.333 8.333S24.333 20.6 24.333 16 20.6 7.667 16 7.667zm.833 12.5h-1.666v-5h1.666v5zm0-6.667h-1.666v-1.667h1.666V13.5z"
        />
      </g>
    </svg>
  )
}

export default Info
